import React from 'react';

interface StepProps {
  recordId: string; // The record ID passed to the component
  handleClose: () => void; // Function to close the popup
  onUpdate: (updatedRecord: any) => void; // Function to handle updates
  handleInputChange: (event: React.ChangeEvent<HTMLTextAreaElement>) => void; // Textarea change handler
  formData: { disabledSources?: string }; // The form data (with disabledSources as optional)
}

const SubidWhitelistingPopupProps: React.FC<StepProps> = ({
  recordId,
  handleClose,
  onUpdate,
  handleInputChange,
  formData,
}) => {
  const handleSave = () => {
    const updatedRecord = {
      recordId,
      disabledSources: formData.disabledSources || '', // Ensure disabledSources is handled safely
    };
    onUpdate(updatedRecord);
    handleClose();
  };

  return (
    <div className="popup-container">
      <div className="popup-header">
        <h4 style={{fontSize:'12px'}}>Campaign: Traffic Source Targeting</h4>
      </div>
      <div className="popup-content">
        <p style={{fontSize:'12px', color:'#990429', fontWeight:'500'}}>
          
Please use the following tool with caution and make sure you are tracking your campaign well and that you know what you are doing. If needed, please consult our support team.
        </p>
        <p style={{fontSize:'12px'}}>
        Traffic Source Targeting gives you better control over your origins of traffic. Each of our traffic sources has its own ID and using the tool below you can whitelist sources that are performing well for you. Simply type below, one source per line, each source that you wish to get traffic from.
        <br></br>   <br></br> 
        Remember - once you add even one whitelisted subid, this campaign will only receive traffic from whitelisted subids. All other subids will be automatically excluded.
        </p>
        <label htmlFor="disabledSources" style={{fontSize:'10px', color:'#990429', fontWeight:'400', display: 'block', marginBottom: '0px' }}>
        <strong style={{fontSize:'12px'}}>Whitelisted Sources</strong> (sources listed below will not be sending you traffic):
        </label>
        <textarea
          id="disabledSources"
          name="disabledSources"
          value={formData.disabledSources || ''} // Fallback to an empty string if undefined
          onChange={handleInputChange}
          rows={8}
          style={{
            width: '50%',
            marginTop: '10px',
            height:'250px',
            padding: '10px',
            border: '1px solid lightgray',
            borderRadius: '5px',
          }}
        />

        <p style={{fontSize:'12px', color:'#990429', fontWeight:'500'}}>There will be no traffic sent from subids marked with ** because they do not match the campaign's "Traffic Source Type" (Mainstream)
        </p>
      </div>

      <div className="popup-actions" style={{ textAlign: 'center', marginTop: '20px' }}>
        <button
          style={{
            padding: '7px 40px',
            backgroundColor: '#1173B7',
            color: 'white',
            fontSize: '12px',
            border: 'none',
            // borderRadius: '5px',
            cursor: 'pointer',
            
          }}
          onClick={handleSave}
        >
          Update
        </button>
      </div>
    </div>
  );
};

export default SubidWhitelistingPopupProps;
